import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { SegmentoIngreso } from '../_models/segmento-ingreso';

@Injectable({
  providedIn: 'root'
})
export class SegmentoIngresoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/segmentosIngresos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as SegmentoIngreso[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as SegmentoIngreso[] ) );
  }

  obtenerPorSegmento( idSegmento: string ) {
    return this.httClient.get( this.rutServicio + '/segmento/' + idSegmento ).pipe( map( res => res as SegmentoIngreso[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as SegmentoIngreso ) );
  }

  agregar( regCrear: SegmentoIngreso ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as SegmentoIngreso ) );
  }

  actualizar( regActualizar: SegmentoIngreso ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as SegmentoIngreso ) );
  }

  listadoTipoOcupacionHabilitados(idTipoOcupacion: string) {
    return this.httClient.get( this.rutServicio + '/segmento' + '/' + idTipoOcupacion + '/filter' ).pipe( map( res => res as SegmentoIngreso[] ) );
  }

}
